/** @firescoutMockFn lusiniFunctions.fetch */
export default function lusiniFunctionsFetch<Result>(
  url: string,
  options: Parameters<typeof fetch>[1]
): Promise<Result> {
  return fetch(url, options).then((res) => res.json())
}
